
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProfileSwitchProvider } from "@/contexts/ProfileSwitchContext";
import DomainRouter from "@/components/routes/DomainRouter";
import { createOptimizedQueryClient, logSlowQueries } from "@/utils/queryOptimizations";

const queryClient = createOptimizedQueryClient();

// Enable performance monitoring in development
if (import.meta.env.DEV) {
  logSlowQueries(queryClient);
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AuthProvider>
          <ProfileSwitchProvider>
            <DomainRouter />
            <Toaster />
            <Sonner />
          </ProfileSwitchProvider>
        </AuthProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
